export default __webpack_public_path__ + "static/media/hep.b9b0ea74.jpg";